import { render, staticRenderFns } from "./SimpleVerifyCode.vue?vue&type=template&id=4c6e3724&scoped=true"
import script from "./SimpleVerifyCode.vue?vue&type=script&lang=js"
export * from "./SimpleVerifyCode.vue?vue&type=script&lang=js"
import style0 from "./SimpleVerifyCode.vue?vue&type=style&index=0&id=4c6e3724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e3724",
  null
  
)

export default component.exports